import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M.;</li>
                            <li>Axial Osso;</li>
                            <li>Sagital P.M. Orbita Direita;</li>
                            <li>Sagital P.M. Orbita Esquerda;</li>
                            <li>Sagital Osso Orbita Direita;</li>
                            <li>Sagital Osso Orbita Esquerda;</li>
                            <li>Coronal P.M.;</li>
                            <li>Coronal Osso;</li>
                            <li>3D VR Orbitas Dir. / Esq.;</li>
                            <li>3D VR Orbitas Sup. / Inf.;</li>
                            <li>3D MIP Orbitas Dir. / Esq.;</li>
                            <li>3D MIP Orbitas Sup. / Inf.;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}